import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../../service/auth.service';

@Injectable({
  providedIn: 'root'
})
export class LoginRedirectGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): boolean {
    // Si l'utilisateur est déjà connecté avec un token valide, rediriger vers le comparateur
    if (this.authService.isTokenValid()) {
      console.log('✅ Utilisateur déjà connecté avec token valide - Redirection vers choix du module');
      this.router.navigate(['/select-module']);
      return false;
    }
    return true;
  }
}
